// src/slices/agentManagement/thunk.ts
// Async thunks for Agent Management

import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAgents,
  createNewAgent,
  updateExistingAgent,
  checkAgentCodeAvailability,
  previewAgentCode,
  updateAgentStatus,
} from "../../helpers/fakebackend_helper";
import { IAgent, AgentFilter } from "./types";
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('agent_management_messages');

// Fetch agents list
export const fetchAgents = createAsyncThunk(
  "AgentManagement/fetchAgents",
  async (params: AgentFilter, { rejectWithValue }) => {
    try {
      const response = await getAgents(params);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch agents"
      );
    }
  }
);

// Create new agent - NO TOAST HERE (handled in component)
export const createAgent = createAsyncThunk(
  "AgentManagement/createAgent",
  async (data: IAgent, { rejectWithValue }) => {
    try {
      const response = await createNewAgent(data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Update existing agent - NO TOAST HERE (handled in component)
export const updateAgent = createAsyncThunk(
  "AgentManagement/updateAgent",
  async (data: IAgent, { rejectWithValue }) => {
    try {
      const response = await updateExistingAgent(data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Check code uniqueness
export const checkAgentCode = createAsyncThunk(
  "AgentManagement/checkCode",
  async (code: string, { rejectWithValue }) => {
    try {
      const response = await checkAgentCodeAvailability(code);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Lấy trước Mã đại lý tự động sinh (mục 8.4, READE.md) — gọi khi mở form Thêm đại lý
export const previewNextAgentCode = createAsyncThunk(
  "AgentManagement/previewCode",
  async (_: void, { rejectWithValue }) => {
    try {
      const response = await previewAgentCode();
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || st('khong_the_lay_ma_dai_ly_message')
      );
    }
  }
);

// Cập nhật trạng thái đại lý (mục 8.8, READE.md)
export const changeAgentStatus = createAsyncThunk(
  "AgentManagement/updateStatus",
  async ({ id, status }: { id: number; status: string }, { rejectWithValue }) => {
    try {
      const response = await updateAgentStatus(id, status);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || st('khong_the_cap_nhat_trang_thai_message')
      );
    }
  }
);